module.exports = __webpack_public_path__ + "img/game_gegame_x.6c929fe.jpg";